import React from 'react';
import { useSelector } from 'react-redux';
import { AftermarketLicenceType } from '@trnsact/trnsact-shared-types';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  children: React.ReactNode;
  licenceType: AftermarketLicenceType[];
}

export const AftermarketProductPermissions = ({ children, licenceType }: Props) => {
  const account = useSelector((state: any) => state.account);
  const aftermarketLicenceType = useSelector(portalConfigurationsSelectors.aftermarketLicenceType);

  const isPartnerAccount = account.accountType === 'Partner';

  return (
    <RenderWithCondition condition={isPartnerAccount || licenceType.includes(aftermarketLicenceType)}>
      {children}
    </RenderWithCondition>
  );
};
